import React, { createContext, useState, useContext, useEffect } from "react";

const lightColors = {
  primary: "#609BAB", // Bleu prioritaire
  secondary: "#E87E58", // Orange doux
  accent: "#6B7280", // Gris foncé pour contraste
  background: "#ffffff", // Fond clair
  text: "#1F2937", // Texte sombre
  border: "#D1D5DB", // Bordure douce
  hover: "#4F8699", // Bleu plus foncé au survol
  active: "#547C8F", // Bleu légèrement plus saturé pour actif
};

const darkColors = {
  primary: "#609BAB", // Bleu prioritaire (contraste élevé)
  secondary: "#E87E58", // Orange doux
  accent: "#A1A1AA", // Gris clair pour détails
  background: "#1F2937", // Fond sombre
  text: "#F9FAFB", // Texte clair
  border: "#4B5563", // Bordure grise
  hover: "#4F8699", // Bleu plus clair au survol
  active: "#547C8F", // Bleu légèrement plus saturé pour actif
};
// ajouté deja payé ou a payer
const ThemeContext = createContext(undefined);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  const [colors, setColors] = useState(lightColors);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", theme);
    setColors(theme === "dark" ? darkColors : lightColors);
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
